const wowApp = require('angular').module('wowApp.shop');
wowApp.directive('bwsButtonStateIcon', [require('./button-state-icon-directive')]);



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/button-state-icon/index.js
 **/